import { useState, useEffect } from 'react';
import tw from 'tailwind-styled-components';
import { capitalizeFirstLetter } from "../helpers";

const statusLabels = {
    1: "PENDING",
    2: "REQUESTED",
    3: "OCCUPIED",
    4: "MOVING_OUT",
    5: "RESERVED"
};

const statusColors = {
    1: "bg-gray-100 text-gray-500",
    2: "bg-red-100 text-red-500",
    3: "bg-green-100 text-green-500",
    4: "bg-orange-100 text-orange-500",
    5: "bg-purple-100 text-purple-500",
    6: "bg-yellow-100 text-yellow-500",
    7: "bg-purple-100 text-purple-500",
};
const getStatusLabel = (status) => statusLabels[status] || "INACTIVE";
const getStatusColor = (status) => statusColors[status] || "bg-gray-200 text-gray-600";
const TopSearchDropdown = ({ options, name, onChange }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [selectedOption, setSelectedOption] = useState([]);
    const [closeTimeout, setCloseTimeout] = useState(null);

    useEffect(() => {
        setIsOpen(true);
    }, [options]);

    const handleOptionSelect = (option) => {
        onChange(option);
        setSelectedOption(option);
        setIsOpen(false);
    };

    useEffect(() => {
        return () => {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }
        };
    }, [closeTimeout]);

    return (
        <DropdownContainer >
            {isOpen && (
                <DropdownMenu
                >
                    {options.map((option) => {
                        return (
                            <Card
                                key={option?.occupancyId}
                                onClick={() => handleOptionSelect(option)}
                            >
                                <Header>
                                    <Name>{capitalizeFirstLetter(option?.inventoryName)}</Name>
                                    {/* <Status $status={option?.status}>{option.type === 'moveOut' ? 'InActive' : getStatusLabel(option.status)}</Status> */}
                                </Header>

                                <Details>
                                    <Item title="Active Tenants">
                                        {/* <Role>{'#' + option.roomNum + ", " + option.flatName + ", " + option.propName}</Role> */}
                                        {/* <Role>{'#'+ option.address + ", " + option.carpetArea + ", " + option.buildUpArea }</Role> */}
                                        <Role>
                                        {
                                            '#' + [option.address, option.carpetArea, option.buildUpArea]
                                            .filter(val => val !== null && val !== undefined && val !== "")
                                            .join(", ")
                                        }
                                        </Role>

                                    </Item>
                                    
                                </Details>
                            </Card>
                        );
                    })}
                </DropdownMenu>
            )}
        </DropdownContainer>
    );
};

const DropdownContainer = tw.div`relative rounded-sm custom-scrollbar w-[410px]`;
const DropdownMenu = tw.div`absolute top-full left-0 bg-white  rounded-b-lg shadow-lg z-10 transition-opacity duration-300 ease-in-out mt-3 overflow-y-scroll max-h-60 w-[410px]`;
const Card = tw.div`p-3 hover:bg-slate-50 transition cursor-pointer border-b border-gray-200 last:border-b-0 w-[400px]`;
const Header = tw.div`flex justify-between items-start mb-1`
const Name = tw.div`text-gray-800 text-md`;
const Details = tw.div`flex items-center justify-between text-sm text-gray-600`
const Item = tw.div`flex items-center gap-1`
const Role = tw.div`text-sm text-primary-color`;
const Status = tw.div`text-[10px] px-2.5 w-auto h-6 flex items-center justify-center rounded-full  ${({ $status }) => getStatusColor($status)}`;

export default TopSearchDropdown;